import { Box, Card, PageBlock, Stack } from 'braid-design-system';
import React, { Fragment } from 'react';

import { FaqAccordion } from 'src/components/FaqAccordion/FaqAccordion';
import Header from 'src/components/Header/Header';

import { isFreemiumExperiment } from '../../data/listing-products/products';

import { faqs, faqsFreemium } from './components/Packages/FaqContent';
import Packages from './components/Packages/Packages';

const PackagesPage = () => (
  <Fragment>
    <Header title="Sell your business" />
    <PageBlock width="large">
      <Box marginY="medium">
        <Card>
          <Stack space="xlarge">
            <Packages />
            <FaqAccordion
              faqs={isFreemiumExperiment ? faqsFreemium : faqs}
              headerWeight="weak"
            />
          </Stack>
        </Card>
      </Box>
    </PageBlock>
  </Fragment>
);

export default PackagesPage;
